import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { RequireAuth } from "./components/RequireAuth";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ContractsPage } from "./pages/ContractsPage";
import { SalesPage } from "./pages/SalesPage";
import { TenantsPage } from "./pages/TenantsPage";
import { TenantDetailPage } from "./pages/TenantDetailPage";
import { PlansPage } from "./pages/PlansPage";
import { AuditPage } from "./pages/AuditPage";
import { ResourcesPage } from "./pages/ResourcesPage";
import { ResourceLogosPage } from "./pages/ResourceLogosPage";
import { ResourceOverviewPage } from "./pages/ResourceOverviewPage";
import { ResourceApiKeysPage } from "./pages/ResourceApiKeysPage";
import { ResourceStagingPage } from "./pages/ResourceStagingPage";
import { ResourcePendingPage } from "./pages/ResourcePendingPage";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/sales" element={<SalesPage />} />
          <Route path="/tenants" element={<TenantsPage />} />
          <Route path="/tenants/:id" element={<TenantDetailPage />} />
          <Route path="/contracts" element={<ContractsPage />} />
          <Route path="/plans" element={<PlansPage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/logos" element={<ResourceLogosPage />} />
          <Route path="/resources/overview" element={<ResourceOverviewPage />} />
          <Route path="/resources/api-keys" element={<ResourceApiKeysPage />} />
          <Route path="/resources/staging" element={<ResourceStagingPage />} />
          <Route path="/resources/pending" element={<ResourcePendingPage />} />
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
